import React from "react";
import SeeMore from "../SeeMore";
import { formatPhone } from "../../../../shared/utils";

const LatamPhoneWarning = ({ phoneMultiplus }) => {
	const urlUpdatePhoneMultiplus =
		"https://www.pontosmultiplus.com.br/portal/pages/meusDados/MeusDados.html";

	return (
		<SeeMore>
			<strong>Atenção ao telefone cadastrado no Latam Pass!</strong>
			<p>A Latam envia um código via SMS para confirmar cada emissão de passagem.</p>
			<p>
				<span>
					Para fazer sua venda, adicione o número <b>{formatPhone(phoneMultiplus)}</b> como telefone
					celular na sua conta Latam Pass,{" "}
					<a href={urlUpdatePhoneMultiplus} target="_blank">
						clique aqui
					</a>{" "}
					para ver os detalhes dessa alteração.
				</span>
			</p>
			<p>
				Depois, é só atualizar este campo informando o número da MaxMilhas que você colocou no Latam
				Pass.
			</p>
			<p>
				<b>Se já tem um telefone da MaxMilhas cadastrado, é só aproveitar suas vendas!</b>
			</p>

			{!window.isWebview && (
				<button
					data-action="update-phone-multiplus"
					className="btn-primary-md"
					onClick={() => window.open(urlUpdatePhoneMultiplus, "_blank")}
					target="_blank"
				>
					Alterar telefone no Latam Pass
				</button>
			)
			}
		</SeeMore >
	);
};

export default LatamPhoneWarning;
